import { addMinutes } from "date-fns";
import {
  isFinishAtType,
  isRemainingTimeType,
} from "@circle-react/helpers/paywallCustomizationHelpers";
import { type PaywallCustomization } from "@circle-react/types/PaywallCustomization";
import { formatCountdownTimer } from "../helpers";

interface UseCountdownPreviewProps {
  countdownProperties: PaywallCustomization["countdown_properties"];
}

export const useCountdownPreview = ({
  countdownProperties,
}: UseCountdownPreviewProps) => {
  let timeRemainingText = "";

  if (isRemainingTimeType(countdownProperties.countdown_type)) {
    timeRemainingText = formatCountdownTimer(
      addMinutes(
        new Date(),
        Number(countdownProperties.remaining_time),
      ).toISOString(),
    );
  }

  if (isFinishAtType(countdownProperties.countdown_type)) {
    timeRemainingText = formatCountdownTimer(
      countdownProperties.finish_at || new Date().toISOString(),
    );
  }

  return {
    timeRemainingText,
  };
};
